async function getUserSavesCount() {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/saves/count`;

  const response = await fetch(url, { credentials: "include" });
  const result = await response.json();

  const userSavesCount = result.count;
  return userSavesCount;
}

export default getUserSavesCount;
